/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CustomFontDestroyPathParams, CustomFontDestroyResponse } from '../types/CustomFontDestroy'

/**
 * DELETE /organisations/:organisation/fonts/:media
 * @see backend/nexus/modules/Organisation/Http/Controllers/CustomFontController.php CustomFontController::destroy
 */
export async function customFontDestroy(
	organisation: CustomFontDestroyPathParams['organisation'],
	media: CustomFontDestroyPathParams['media'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomFontDestroyResponse>> {
	return axiosInstance.delete(`/organisations/${organisation}/fonts/${media}`, config)
}
